import PartnerModuleSlice from "../slices/partnermodule.slice";
import WithdrawlSlice from "../slices/withdrawal.slice";
import DashboardSlice from "../slices/dashboard.slice";
import DeliverySlice from "../slices/delivery.slice";
import { combineReducers } from "@reduxjs/toolkit";
import PartnerSlice from "../slices/partner.slice";
import MessageSlice from "../slices/message.slice";
import EarningSlice from "../slices/earning.slice";
import SidebarSlice from "../slices/sidebarslice";
import FilterSlice from "../slices/filter.slice";
import AdminSlice from "../slices/admin.slice";
import UsersSlice from "../slices/users.slice";
import otherSlice from "../slices/other.slice";
import RideSlice from "../slices/rides.slice";
import AuthSlice from "../slices/auth.slice";
import BankSlice from "../slices/bank.slice";

const rootReducer = combineReducers({
  BankSlice,
  RideSlice,
  AuthSlice,
  otherSlice,
  UsersSlice,
  AdminSlice,
  FilterSlice,
  PartnerSlice,
  MessageSlice,
  EarningSlice,
  SidebarSlice,
  DeliverySlice,
  DashboardSlice,
  WithdrawlSlice,
  PartnerModuleSlice,
})

export default rootReducer